import { DisconnectedError } from '../../utils/errors.js';
function buildDisconnectedError(error) {
    return {
        statusCode: error.statusCode,
        type: error.name,
        message: error.message,
    };
}
function buildIgnoredAbortedError(error) {
    return {
        statusCode: error.code,
        type: error.name,
        message: error.message,
        ignored: true,
    };
}
export function buildAPIResponseFromErrorOrThrow(error, disableAbortWarning) {
    if (disableAbortWarning && error.name === 'AbortError') {
        return {
            error: buildIgnoredAbortedError(error),
        };
    }
    if (error instanceof DisconnectedError) {
        return { error: buildDisconnectedError(error) };
    }
    throw error;
}
